import type { FieldsDataStructure } from "../types/keyword.types";

export const fieldsData: FieldsDataStructure = {
  general: {
    label: "General",
    subFields: [
      "Date Published",
      "Platform",
      "Word Count",
      "Total Mentions",
      "Publisher",
      "Post URL",
      "Language",
      "Title",
      "Entities",
      "Influencer",
      "Content",
      "Keywords",
      // "Engagement",
    ],
  },
  facebook: {
    label: "Facebook",
    subFields: [
      "FB Likes",
      "FB Comments",
      "FB Shares",
      "FB Views",
      "FB Wow",
      "FB Haha",
      "FB Sad",
      "FB Angry",
      "FB Love",
      "FB Care",
      // "FB Engagement",
      "FB Total Mentions",
    ],
  },
  twitter: {
    label: "X/Twitter",
    subFields: [
      "Twitter Likes",
      "Twitter Retweets",
      "Twitter Comments",
      "Twitter Replies",
    ],
  },
  instagram: {
    label: "Instagram",
    subFields: ["IG Likes", "IG Comments"],
  },
  youtube: {
    label: "YouTube",
    subFields: ["YT Likes", "YT Views", "YT Comments"],
  },
  reddit: {
    label: "Reddit",
    subFields: [
      "Subreddit Name",
      "Number of Awards",
      "Number of Members",
      "Post Description",
      "Number of Comments",
      "Rank by Population",
      "Subreddit URL",
      "Votes",
      "Downvotes",
    ],
  },
  tiktok: {
    label: "TikTok",
    subFields: [
      "TikTok Likes",
      "TikTok Comments",
      "TikTok Reposts",
      "Number of Views/Plays",
    ],
  },
};

export const fieldMapByPlatform: Record<string, Record<string, string>> = {
  GENERAL: {
    "Date Published": "date_publish",
    Platform: "soc_source",
    "Post URL": "article_url",
    Language: "language",
    Entities: "entities_id",
    Influencer: "influencer",
    Content: "content",
    Publisher: "publisher",
    "Word Count": "word_count",
    "Total Mentions": "total_mentions",
    Title: "title",
    Keywords: "keywords",
    Engagement: "engagement",
  },
  YOUTUBE: {
    "YT Views": "soc_view_count",
    "YT Likes": "soc_like_count",
    "YT Comments": "soc_comment_count",
  },
  TWITTER: {
    "Twitter Likes": "soc_like_count",
    "Twitter Comments": "soc_comment_count",
    "Twitter Retweets": "soc_share_count",
    "Twitter Replies": "soc_reply_count",
  },
  INSTAGRAM: {
    "IG Likes": "soc_like_count",
    "IG Comments": "soc_comment_count",
  },
  TIKTOK: {
    "TikTok Likes": "soc_like_count",
    "TikTok Comments": "soc_comment_count",
    "TikTok Reposts": "soc_share_count",
    "Number of Views/Plays": "soc_view_count",
  },
  FACEBOOK: {
    "FB Likes": "soc_like_count",
    "FB Comments": "soc_comment_count",
    "FB Shares": "soc_share_count",
    "FB Views": "soc_view_count",
    "FB Wow": "soc_wow_count",
    "FB Haha": "soc_haha_count",
    "FB Sad": "soc_sad_count",
    "FB Angry": "soc_angry_count",
    "FB Love": "soc_love_count",
    "FB Total Mentions": "soc_total_mentions",
  },
  REDDIT: {
    "Subreddit Name": "subreddit_name",
    "Number of Awards": "reddit_awards",
    "Number of Members": "subreddit_members",
    "Post Description": "post_description",
    "Number of Comments": "soc_comment_count",
    "Rank by Population": "subreddit_rank",
    "Subreddit URL": "subreddit_url",
    Votes: "soc_like_count",
    Downvotes: "soc_dislike_count",
  },
};
